import { Cta, Headline, Subheadline, StyledCtaSection, LegalText } from "./GHCtaSection.styles"
import React, { useContext } from 'react';

import { AnalyticsContext } from "../../../context";
import PropTypes from 'prop-types';
import { getPageSlug } from '../../../../helpers';

const GHCtaSection = (props) => {
  const { handleTealiumEvent } = useContext(AnalyticsContext)

  const getLeftRightBackgrounds = ( position ) =>{
    console.log('props.multipleBackgrounds::', props.multipleBackgrounds);
    let  hideMobileClass = props.hideGraphicsMobile ? ' graphic-hide' : '',
        classPosition = " gh-cta-graphic-" + position + hideMobileClass,
        styleObject = { backgroundImage: '', ...props.graphicLeftStyle };

    switch ( position ){
      case "left":
        styleObject.backgroundImage = 'url("' + props.graphicLeftSrc + '")';
        styleObject.width = "145px";
        styleObject.height = "281px";
        styleObject.backgroundSize = "contain";
        styleObject.left = "0px";
        styleObject.top = "50%";
        styleObject.transform = "translateY(-50%)";
        break;
      case "right":
        styleObject.backgroundImage = 'url("' + props.graphicRightSrc + '")';
        styleObject.width = "143px";
        styleObject.height = "266px";
        styleObject.backgroundSize = "contain";
        styleObject.right = "0px";
        styleObject.top = "50%";
        styleObject.transform = "translateY(-50%)";
        break;
      case "top":
        styleObject.backgroundImage = 'url("' + props.graphicTopSrc + '")';
        break;
      case "bottom":
        styleObject.backgroundImage = 'url("' + props.graphicBottomSrc + '")';
        break;
    }


    return (
        <div
            className={'gh-cta-graphic' + classPosition }
            style={styleObject}
        ></div>
    )
  }


  return(
  <StyledCtaSection shrinkGraphicMobile={props.shrinkGraphicMobile} topSpacing={props.topSpacing} bottomSpacing={props.bottomSpacing} bottomSpacingMobile={props.bottomSpacingMobile} topSpacingMobile={props.topSpacingMobile} className={'gh-cta-section'} graphicTopPosition={props.graphicTopPosition}  graphicBottomPosition={props.graphicTopPosition} backgroundColor={props.backgroundColor} maxWidth={props.maxWidth}>
    {
       props.graphicLeftSrc &&
        getLeftRightBackgrounds( "left")
    }
{
       props.graphicRightSrc &&
        getLeftRightBackgrounds( "right")
    }

    {props.graphicTopSrc &&
        <div
            className={'gh-cta-graphic gh-cta-graphic-top' + ( props.graphicTopPosition ? props.graphicTopPosition : '' )}
            style={{ ...{ backgroundImage: 'url("' + props.graphicTopSrc + '")' }, ...props.graphicTopStyle}}
        ></div>
    }
    {props.graphicBottomSrc &&
        <div
            className={'gh-cta-graphic gh-cta-graphic-bottom' + ( props.graphicBottomPosition ? props.graphicBottomPosition : '' )}
            style={{ ...{ backgroundImage: 'url("' + props.graphicBottomSrc + '")' }, ...props.graphicBottomStyle }}
        ></div>
    }
    <div className={'container-cta'}>
      {props.headline ? <Headline>{props.headline}</Headline> : ""}
      {props.subheadline ? <Subheadline>{props.subheadline}</Subheadline> : ""}
      <div className={'buttons-wrapper'}>
      {
        ! props.hideButton &&
          <Cta
            to={props.to}
            type={props.buttonType}
            onClick={() => handleTealiumEvent({ eventcategory: `${props.eventcategory}`, eventaction: `${props.eventaction}`, eventlabel: `${props.eventlabel}` })}
          >
            {props.ctaText}
          </Cta>
      }
      {
        ! props.hideButtonTwo &&
          <Cta
            to={props.secondButtonTo}
            type={props.secondButtonType}
            onClick={() => handleTealiumEvent({ eventcategory: `${props.eventcategory}`, eventaction: `${props.eventaction}`, eventlabel: `${props.eventlabel}` })}
          >
            {props.secondCtaText}
          </Cta>
      }
      </div>
      {props.legal ? <LegalText>{props.legal}</LegalText> : ""}
    </div>
  </StyledCtaSection>
  )
};

GHCtaSection.propTypes = {
  headline: PropTypes.string,
  to: PropTypes.string,
  ctaText: PropTypes.string,
  secondButtonTo: PropTypes.string,
  secondCtaText: PropTypes.string,
  secondButtonType: PropTypes.string,
  backgroundColor: PropTypes.string,
  topSpacing: PropTypes.string,
  topSpacingMobile: PropTypes.string,
  bottomSpacing: PropTypes.string,
  bottomSpacingMobile: PropTypes.string,
  hideButton: PropTypes.bool,
  buttonType: PropTypes.string,
  eventcategory: PropTypes.string,
  eventaction: PropTypes.string,
  eventlabel: PropTypes.string,
  maxWidth: PropTypes.string,
  multipleBackgrounds: PropTypes.array,
  graphicTopSrc: PropTypes.string,
  graphicTopPosition: PropTypes.string,
  graphicTopStyle: PropTypes.string,
  graphicTopMobileSrc: PropTypes.string,
  graphicTopMobileSrcStyle: PropTypes.string,
  graphicBottomSrc: PropTypes.string,
  graphicBottomPosition: PropTypes.string,
  graphicBottomStyle: PropTypes.string,
  graphicLeftSrc: PropTypes.string,
  graphicLeftStyle: PropTypes.string,
  graphicBottomMobile: PropTypes.string,
  graphicBottomMobileStyle: PropTypes.string,
  graphicRightSrc: PropTypes.string,
  graphicRightStyle: PropTypes.string,
  hideGraphicsMobile: PropTypes.bool,
  shrinkGraphicMobile: PropTypes.bool,
};

GHCtaSection.defaultProps = {
  headline: "",
  to: "/get-started/",
  ctaText: "Get started",
  hideButtonTwo: true,
  secondButtonTo: '/',
  secondCtaText: 'Get started 2',
  secondButtonType: 'secondary',
  backgroundColor: null,
  topSpacing: null,
  topSpacingMobile: null,
  bottomSpacing: null,
  bottomSpacingMobile: null,
  hideButton: false,
  buttonType: "primary",
  eventcategory: `${getPageSlug()} interaction`,
  eventaction: "get started_cta",
  eventlabel: "see what we can do for you",
  maxWidth: null,
  multipleBackgrounds: null,
  graphicTopSrc: null,
  graphicTopPosition: null,
  graphicTopStyle: null,
  graphicTopMobileSrc: null,
  graphicTopMobileSrcStyle: null,
  graphicBottomSrc: null,
  graphicBottomPosition: null,
  graphicBottomStyle: null,
  graphicBottomMobile: null,
  graphicBottomMobileStyle: null,
  graphicLeftSrc: null,
  graphicLeftStyle: null,
  graphicRightSrc: null,
  graphicRightStyle: null,
  graphicRightMobileSrc: null,
  graphicRightMobileStyle: null,
  hideGraphicsMobile: false,
  shrinkGraphicMobile: false,

};

export default GHCtaSection;
